import * as React from 'react';

import { useScrolledIntoView } from '../../hooks';
import { useSpring, animated } from 'react-spring';

import s from './ImageGallery.module.scss';
import { Image as ImageType, renditions } from '../../types';
import Image from "../Image";
import {MediaQuery} from "../Image/Image";
import classNames from 'classnames';

export interface ImageGalleryProps {
    images?: Array<ImageType>;
    tag?: string;
    title?: string;
    text?: string;
}

const ImageGallery: React.FC<ImageGalleryProps> = (props) => {
    const {
        images = [],
        title,
        text,
    } = props;

    const [ViewSensor, isInView] = useScrolledIntoView({ partialVisibility: true });
    const fadeInProps = useSpring({
        opacity: isInView ? 1 : 0.001,
        transform: isInView
            ? `translate3d(0, 0, 0)`
            : `translate3d(0, 60px, 0)`
    });

    const getMediaQueries = (renditions: renditions): MediaQuery[] => {
        let mediaQueries = [];
        mediaQueries = [
            ...mediaQueries,
            { minWidth: 960, src: renditions?.xl?.src },
            { minWidth: 768, src: renditions?.large?.src },
            { minWidth: 480, src: renditions?.medium?.src },
            { minWidth: 360, src: renditions?.small?.src },
        ];

        return mediaQueries.filter((x) => x.src);
    }

    return (
        <ViewSensor>
            <animated.article className={s.Root} style={fadeInProps}>
            <div className={classNames(s.ImageWrap, s["ImageWrap--Top"])}>
                    {images && (
                        [...images].slice(0,2).map((image, index) =>
                            <Image
                                key={index}
                                image={image}
                                containerClass={classNames(s.ImageContainer, s[`ImageContainer--${index}`])}
                                className={s.Image}
                                mediaQueries={getMediaQueries(image.renditions)}
                            />
                        )
                    )}
                </div>
                <div className={s.Intro}>
                    <h3 className={s.Caption}>
                        <span dangerouslySetInnerHTML={{ __html: title }} />
                    </h3>
                    <p className={s.Text}>
                        <span dangerouslySetInnerHTML={{ __html: text }} />
                    </p>
                </div>

                <div className={classNames(s.ImageWrap, s["ImageWrap--Bottom"])}>
                    {images && (
                        [...images].slice(2,4).map((image, index) =>
                            <Image
                                key={index}
                                image={image}
                                containerClass={classNames(s.ImageContainer, s[`ImageContainer--${index+2}`])}
                                className={s.Image}
                                mediaQueries={getMediaQueries(image.renditions)}
                            />
                        )
                    )}
                </div>
                {(images.length >= 4) && (
                    <Image
                        image={images[4]}
                        containerClass={classNames(s.ImageContainer, s["ImageContainer--4"]) }
                        className={s.Image}
                        mediaQueries={getMediaQueries(images[4].renditions)}
                    />
                )}
            </animated.article>
        </ViewSensor>
    );
};

export default ImageGallery;
